import { Card, Text } from '@mantine/core'

export function YearSummaryCard() {
  // Mock data - would come from API
  const totalTasks = 34
  const markkuTasks = 30
  const savedHours = 20

  return (
    <Card
      radius="lg"
      withBorder
      p="sm"
      style={{
        background: 'linear-gradient(135deg, #FFF8F3 0%, #FFEDE0 100%)',
        borderColor: 'var(--mantine-color-brandOrange-2)',
      }}
    >
      <Text size="sm">
        Vuoden{' '}
        <Text component="span" fw={700}>
          {totalTasks}
        </Text>{' '}
        tehtävästä{' '}
        <Text component="span" c="brandOrange.7" fw={600}>
          Markku hoitaa {markkuTasks}
        </Text>
        , säästäen sinulta arviolta{' '}
        <Text component="span" c="brandOrange.7" fw={700}>
          {savedHours} tuntia
        </Text>
        .
      </Text>
    </Card>
  )
}
